/**
 * 全局方法
 */
import Vue from 'vue'
import merge from 'webpack-merge'
import Cookies from 'js-cookie'
import $ from 'jquery'
import {
  mapGetters,
  mapMutations
} from 'vuex'
import store from '../../store/'
import {
  messages
} from 'element-ui'

Vue.prototype.$message = messages
export default new Vue({
  data () {
    return {
      port: window.location.port,
      chars: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      showLogInvalidErrorTime: false
    }
  },
  created () {
    this.$store = store
  },
  methods: {
    ...mapGetters(['router', 'highLightInfo']),
    ...mapMutations(['SET_ROUTER', 'SET_HIGH_LIGHT_INFO']),
    initPage (data, params) {
      params = params || {}
      params.pageSize = data.pageSize
      params.pageNum = data.pageNum
      return params
    },
    //获取本地存储的userInfo，并转成对象
    getUserInfo () {
      var userInfo = localStorage.getItem('user_info')
      userInfo = JSON.parse(userInfo)
      // userInfo.roleName = this.getUserRole(userInfo.type)
      return userInfo
    },
    //获取用户的中文角色
    getUserRole (type) {
      var roleName = ''
      if (type == 99999) {
        roleName = '超级管理员'
      } else if (type == 0) {
        roleName = '管理员'
      } else if (type == 1) {
        roleName = '客户'
      } else if (type == 2) {
        roleName = '员工'
      }
      return roleName
    },
    showLoading (message, params) {
      params = params || {}
      this.$Message.loading(
        merge({
          content: message || '加载中',
          duration: 0
        }, params)
      )
    },
    showLogInvalidError () {
      if (!this.showLogInvalidErrorTime || (new Date().getTime() - this.showLogInvalidErrorTime > 5000)) {
        this.showInfo('登录信息失效，请重新登录')
        this.showLogInvalidErrorTime = new Date().getTime()
      }
    },
    showLogout () {
      this.showLogInvalidErrorTime = new Date().getTime()
    },
    showError (message, params) {
      var that = this
      params = params || {}
      // this.$Message.error(
      //   merge({content: message || '操作失败', duration: 1.5}, params)
      // )
      that.$message.error(message)
      // this.$message.error(
      //
      // )
    },
    showErrorDuration (message, params) {
      params = params || {}
      // this.$Message.error(
      //   merge({content: message || '操作失败', duration: 1.5}, params)
      // )
      this.$Notice.error(
        merge({
          desc: message || '操作失败',
          duration: 0,
          top: 120
        }, params)
      )
    },
    showErrorForm () {
      this.destroyShow()
      this.showError('表单校验未通过，请检查表单内容')
    },
    showWarning (message, params) {
      params = params || {}
      // this.$Message.warning(
      //   merge({content: message || '操作有误', duration: 1.5}, params)
      // )
      this.$Notice.warning(
        merge({
          desc: message || '操作有误',
          duration: 3
        }, params)
      )
    },
    showInfo (message, params) {
      params = params || {}
      // this.$Message.info(
      //   merge({content: message || '提示', duration: 1.5}, params)
      // )
      this.$Notice.info(
        merge({
          desc: message || '提示',
          duration: 3
        }, params)
      )
    },
    showSuccess (message, params) {
      params = params || {}
      // this.$Message.success(
      //   merge({content: message || '操作成功', duration: 1.5}, params)
      // )
      // message = (message == null ? '操作成功' : message);
      this.$message.success(message || '操作成功')
    },
    destroyShow () {
      // this.$message.destroy()
    },
    deepCopy (o) {
      /*
      c = c || {}
      const self = this
      for (let i in o) {
        if (typeof o[i] === 'object') {
          //要考虑深复制问题了
          if (o[i] instanceof Array) {
            //这是数组
            c[i] = []
          } else {
            //这是对象
            c[i] = {}
          }
          self.deepCopy(o[i], c[i])
        } else {
          c[i] = o[i]
        }
      } */
      return JSON.parse(JSON.stringify(o))
      // return c
    },
    keyCopy (region, target) {
      target = target || {}
      if (typeof region === 'object') {
        for (let key in region) {
          target[key + ''] = region[key + '']
        }
      } else {
        return target
      }
    },
    replaceAll (str, regStr, targetStr) {
      str = str || ''
      return str.replace(new RegExp(regStr, 'gm'), targetStr)
    },
    timeFormatFun: function (time, format) {
      let t = new Date(time)
      let tf = function (i) {
        return (i < 10 ? '0' : '') + i
      }
      return format.replace(/yyyy|MM|dd|HH|mm|ss|ms/g, function (a) {
        switch (a) {
          case 'yyyy':
            return tf(t.getFullYear())
          case 'MM':
            return tf(t.getMonth() + 1)
          case 'mm':
            return tf(t.getMinutes())
          case 'dd':
            return tf(t.getDate())
          case 'HH':
            return tf(t.getHours())
          case 'ss':
            return tf(t.getSeconds())
          case 'ms':
            return tf(t.getMilliseconds())
        }
      })
    },
    fixNumber (number, fixNumber) {
      fixNumber = Math.pow(10, fixNumber)
      return Math.ceil(Number(number) * fixNumber) / fixNumber
    },
    downloadFile (attachId) {
      window.open('/api/attach/download/' + attachId, '_self')
    },
    downloadFileByName (attachName) {
      window.open('/api/attach/static/download?useCode=' + attachName + '&useType=attach', '_self')
    },
    downloadFileByUrl (url) {
      window.open(url, '_self')
    },
    // 下载带参数
    downLoadFileHaveParams (url, params) {
      let str
      if (params) {
        str = '?'
        if (params.constructor === Object) {
          for (let key in params) {
            str += key + '=' + params[key] + '&'
          }
          str = str.substring(0, str.length - 1)
        } else {
          str = '/' + params
        }
        url += str
      }
      window.open(url, '_self')
    },
    // 批量下载
    downloadFileByUrlAll (url) {
      window.open(url, '_self')
    },
    uploadFile (file, url, fileKey, config) {
      fileKey = fileKey || 'file'
      url = url || '/api/uploadEnclosure'
      let formData = new FormData()
      if (file instanceof Array) {
        for (let key in file) {
          formData.append(fileKey, file[key])
        }
      } else {
        formData.append(fileKey, file)
      }
      // console.log(config)
      // config.headers['Content-Type'] = 'multipart/form-data'
      return this.axios.post(url, formData, config)
    },
    setUserInfo (userInfo) {
      localStorage.clear()
      sessionStorage.clear()
      localStorage.setItem('user_info', userInfo)
    },
    setIdminfo (Idminfo) {
      localStorage.setItem('idm_info', Idminfo)
    },
    destroyUser ($router, type) {
      type = type || 'router'
      $router = $router || this.$router
      localStorage.removeItem('user_info')
      Cookies.remove('userId')
      Cookies.remove('isLogin')
      if (type === 'router') {
        $router.push({
          path: '/'
        })
      } else {
        $router('/')
      }
    },
    reWriteUrl ($router, type) {
      type = type || 'router'
      let tenantId = 0
      let selfServiceId = 0
      let isMenuName = 0
      let first = 0
      let next = 0
      let simulateLogout = localStorage.getItem('ifSimulateLogout')
      $router = $router || this.$router
      if (!localStorage.getItem('user_info')) {
        this.destroyUser($router, type)
        return
      }
      // 修改每个视图的主页面,左侧导航的当前activeName
      let viewArr = JSON.parse(localStorage.getItem('user_info')).roles
      viewArr.forEach((data, index, arr) => {
        if (data.type === '2') {
          arr.splice(index, 1)
        } else {
          if (data.menuId === 'tenant') {
            tenantId = 1
          } else if (data.menuId === 'selfServiceTenant') {
            selfServiceId = 1
          }
          let url = ''
          if (tenantId) {
            for (let i = 0; i < data.children.length; i++) {
              if (data.children[i].children && data.children[i].url === '#') {
                for (let j = 0; j < data.children[i].children.length; j++) {
                  if (data.children[i].children[j].menuName === '共享需求申请') {
                    isMenuName = 1
                    first = i
                    next = j
                    return
                  }
                }
              }
            }
          }
          if (!isMenuName) {
            for (let i = 0; i < data.children.length; i++) {
              if (data.children[i].url !== '#') {
                url = data.children[i].url
                break
              } else {
                url = data.children[i].children[0].url
                break
              }
            }
          }
          data.url = url
        }
        // if (data.type === '1') {
        //
        // }
      })
      let role = viewArr[0] || {}
      // console.log(role)
      // 修改每个视图的主页面,左侧导航的当前activeName
      this.globalMethod.destroyShow()
      if (role && role.url) {
        if (this.port === '7097' || this.port === '7098' || this.port === '7099') {
          if (role.menuId === 'tenant') {
            $router.push('/tenant/fireWallList')
          } else if (role.menuId === 'operation') {
            $router.push('/operation/fireWallList')
          }
        } else {
          if (type === 'router') {
            // $router.push(role.url)
            if (simulateLogout) {
              if (viewArr.length > 1) {
                $router.push('/selectView')
                window.location.reload()
              } else if (selfServiceId && tenantId && isMenuName) {
                $router.push('/selectView')
                window.location.reload()
              } else if (tenantId && isMenuName) {
                sessionStorage.setItem('activeName', role.children[first].children[next].menuId)
                $router.push('/tenant/fillBusinessInfo')
              } else {
                if (role.children && role.children.length > 0) {
                  if (role.children[0].url !== '#') {
                    sessionStorage.setItem('activeName', role.children[0].menuId)
                  } else {
                    sessionStorage.setItem('activeName', role.children[0].children[0].menuId)
                  }
                }
                $router.push(role.url)
              }
            } else {
              if (viewArr.length > 1) {
                $router.push('/selectView')
              } else if (selfServiceId && tenantId && isMenuName) {
                $router.push('/selectView')
              } else if (tenantId && isMenuName) {
                sessionStorage.setItem('activeName', role.children[first].children[next].menuId)
                $router.push('/tenant/fillBusinessInfo')
              } else {
                if (role.children && role.children.length > 0) {
                  if (role.children[0].url !== '#') {
                    sessionStorage.setItem('activeName', role.children[0].menuId)
                  } else {
                    sessionStorage.setItem('activeName', role.children[0].children[0].menuId)
                  }
                }
                $router.push(role.url)
              }
            }
          } else {
            // $router(role.url)
            if (tenantId && isMenuName) {
              sessionStorage.setItem('activeName', role.children[first].children[next].menuId)
              $router.push('/tenant/fillBusinessInfo')
            } else {
              if (role.children && role.children.length > 0) {
                if (role.children[0].url !== '#') {
                  sessionStorage.setItem('activeName', role.children[0].menuId)
                } else {
                  sessionStorage.setItem('activeName', role.children[0].children[0].menuId)
                }
              }
              $router.push(role.url)
            }
          }
        }
      }
    },
    goBack ($router, url) {
      setTimeout(function () {
        if (url) {
          $router.push(url)
        } else {
          $router.go(-1)
        }
      }, 500)
    },
    generateMixed (n) {
      let res = ''
      for (let i = 0; i < n; i++) {
        const id = Math.ceil(Math.random() * 35)
        res += this.chars[id]
      }
      return res
    },
    getDefaultRegistrationData (hasItem) {
      return this.globalMethod.deepCopy({
        file: [],
        fieldAddType: 'field',
        infoResLogicItemList: hasItem ? [{
          time: 0,
          zhName: '', // 中文名称
          // enName: '', // 英文名称
          // itemDescribe: '', // 字段描述
          // objectType: '人员类', // 对象类型
          // dataType: 'VARCHAR', // 数据类型
          // dataLength: 1, // 数据长度
          // isDictionary: '否', // 是否字典项
          // isNull: '是', // 是否为空
          // isPrimary: '否', // 是否主键
          // defaultValue: '', // 默认值
          sharingType: '受限共享', // 共享类型
          sharingCondition: '', // 共享条件
          // sharingModeType: '共享平台', // 共享方式类型
          // sharingMode: '接口', // 共享方式
          // sharingModeTemp: ['接口', '数据库'], // 共享方式,
          isOpen: '是', // 是否开放
          updateCycle: '实时'
          // openCondition: '', // 开放条件
          // source: '' // 来源
        }] : [],
        infoResName: '',
        infoResSummary: '',
        reportedProvince: '是',
        status: 1,
        // infoResFormatType: '数据库',
        // infoResFormatValue: 'mysql',
        topicType: '',
        topicTypeTemp: [],
        keyAreaType: '',
        keyAreaTypeTemp: [],
        systemName: '',
        sharingType: '受限共享',
        sharingCondition: '',
        sharingModeType: '共享平台',
        sharingModeTypeTemp: ['共享平台'],
        sharingMode: '接口,数据库',
        sharingModeTemp: ['接口', '数据库'] // 共享方式,
        // isOpen: '是',
        // openCondition: '',
        // updateCycle: '每日',
        // relationResourceCode: ''
      })
    },
    getNewDefaultRegistrationData (hasItem) {
      return this.globalMethod.deepCopy({
        file: [],
        fieldAddType: 'field',
        infoResLogicItemList: hasItem ? [{
          time: 0,
          zhName: '', // 中文名称
          // enName: '', // 英文名称
          // itemDescribe: '', // 字段描述
          // objectType: '人员类', // 对象类型
          // dataType: 'VARCHAR', // 数据类型
          // dataLength: 1, // 数据长度
          // isDictionary: '否', // 是否字典项
          // isNull: '是', // 是否为空
          // isPrimary: '否', // 是否主键
          // defaultValue: '', // 默认值
          sharingType: '受限共享', // 共享类型
          sharingCondition: '', // 共享条件
          // sharingModeType: '共享平台', // 共享方式类型
          // sharingMode: '接口', // 共享方式
          // sharingModeTemp: ['接口', '数据库'], // 共享方式,
          isOpen: '是', // 是否开放
          updateCycle: '实时'
          // openCondition: '', // 开放条件
          // source: '' // 来源
        }] : [],
        infoResName: '',
        infoResFormatType: '数据库',
        infoResFormatValue: 'mysql',
        status: 1,
        topicType: '',
        topicTypeTemp: [],
        keyAreaType: '',
        keyAreaTypeTemp: [],
        systemName: '',
        sharingType: '受限共享',
        sharingCondition: '',
        sharingModeType: '共享平台',
        sharingModeTypeTemp: ['共享平台'],
        sharingMode: '接口',
        sharingModeTemp: ['接口'] // 共享方式,
      })
    },
    turnObjToArray (obj) {
      let returnArray = []
      for (let key in obj) {
        returnArray.push(obj[key + ''])
      }
      return returnArray
    },
    /**
     * @return {string}
     */
    IPArrToStr (arr) {
      let str = ''
      const len = arr.length
      for (let i = 0; i < len; i++) {
        if (i !== len - 1) {
          str += arr[i].value + '.'
        } else {
          str += arr[i].value
        }
      }
      return str
    },
    validRule (type, filedName, config) {
      filedName = filedName || '该表单项'

      function initValue (key, value) {
        if (ruleObject[key] === undefined) {
          ruleObject[key] = value
        }
      }

      let ruleObject = {
        trigger: 'blur'
      }
      config = config || {}
      ruleObject = merge(ruleObject, config)
      switch (type) {
        case 'required':
          initValue('required', true)
          if (ruleObject['message'] === undefined) {
            ruleObject['message'] = filedName + '不能为空'
          }
          break
        case 'max':
          initValue('max', 100)
          if (ruleObject['message'] === undefined) {
            ruleObject['message'] = filedName + '不能超出' + ruleObject['max'] + '个' + (config.type === 'array' ? '选项' :
              '字符')
          }
          break
        case 'min':
          initValue('min', 10)
          if (ruleObject['message'] === undefined) {
            ruleObject['message'] = filedName + '不能小于' + ruleObject['min'] + '个' + (config.type === 'array' ? '选项' :
              '字符')
          }
          break
        case 'range':
          initValue('min', 0)
          initValue('max', 100)
          initValue('range', [0, 100])
          if (ruleObject['message'] === undefined) {
            ruleObject['message'] = filedName + '必须介于' + ruleObject['range'][0] + '~' + ruleObject['range'][1] +
              '个' + (config.type === 'array' ? '选项' : '字符' + '之间')
          }
          break
      }
      return ruleObject
    },
    requiredRule (filedName, config) {
      return this.validRule('required', filedName, config)
    },
    requiredArrayRule (filedName, config) {
      config = config || {}
      if (!config.type) {
        config.type = 'array'
      }
      if (!config.trigger) {
        config.trigger = 'change'
      }
      return this.validRule('required', filedName, config)
    },
    requiredRuleList (filedName, config) {
      return [this.validRule('required', filedName, config)]
    },
    requiredMaxRuleList (filedName, maxValue, config) {
      return [this.validRule('required', filedName, config), this.maxRule(filedName, maxValue, config)]
    },
    requiredRuleByChange (filedName, config) {
      config = config || {}
      if (config.trigger === undefined) {
        config.trigger = 'change'
      }
      return this.requiredRule(filedName, config)
    },
    contactInformation (trigger) {
      let arr = []
      arr.push({
        required: true,
        message: '请填写正确的手机号或座机号',
        trigger: trigger || 'blur',
        transform (value) {
          // var myreg = /^((0\d{2,3}-\d{7,8})|([1][0-9]{10}))$/
          let myreg = /^(((\+\d{2}-)?0\d{2,3}-\d{7,8})|((\+\d{2}-)?(\d{2,3}-)?([1][0-9]{10}))|\d{7,8})$/
          if (!myreg.test(value)) {
            return false
          } else {
            return value
          }
        }
      })
      return arr
    },
    initDefaultRule (type, filedName, defaultValue, config) {
      config = config || {}
      config[type] = defaultValue
      if (type === 'range') {
        config['min'] = defaultValue[0]
        config['max'] = defaultValue[1]
      }
      return this.validRule(type, filedName, config)
    },
    maxRule (filedName, maxValue, config) {
      return this.initDefaultRule('max', filedName, maxValue || 100, config)
    },
    minRule (filedName, minValue, config) {
      return this.initDefaultRule('min', filedName, minValue || 10, config)
    },
    rangeRule (filedName, rangeValue, config) {
      if (rangeValue === undefined || !(rangeValue instanceof Array) || rangeValue.length < 2 || rangeValue[1] <
        rangeValue[0]) {
        rangeValue = [0, 100]
      }
      return this.initDefaultRule('range', filedName, rangeValue, config)
    },
    checkAdmin () {
      /*
      const userList = JSON.parse(localStorage.getItem('user_info'))
      const userAdmin = userList.roles[0].privileges
      if (userList) {
        let ifMatch = false
        userAdmin.forEach((data, index, array) => {
          if (data.privilegeCode === 'cmp_edit_all' && !ifMatch) {
            ifMatch = true
          } else {
            ifMatch = false
          }
        })
        return ifMatch
      } else {
        return false
      } */
      return true
    },
    getWindowSize () {
      return {
        window: {
          width: $(window).width(), // 浏览器当前窗口可视区域宽度
          height: $(window).height() // 浏览器当前窗口可视区域高度
        },
        document: {
          width: $(document).width(), // 浏览器当前窗口文档对象宽度
          height: $(document).height() // 浏览器当前窗口文档的高度
        },
        body: {
          width: $(document.body).width(), // 浏览器当前窗口文档body的宽度
          height: $(document.body).height() // 浏览器当前窗口文档body的高度
        },
        bodyOuter: {
          width: $(document.body).outerWidth(true), // 浏览器当前窗口文档body的总宽度 包括border padding margin
          height: $(document.body).outerHeight(true) // 浏览器当前窗口文档body的总高度 包括border padding margin
        }
      }
    },
    handleCapacity (value, withCapacity, number) {
      let unitList = ['B', 'KB', 'M', 'G']
      number = number || 0
      if (value < 2014) {
        return this.fixNumber(value, 2) + (withCapacity ? unitList[number] : '')
      } else {
        return this.handleCapacity(value / 1024, withCapacity, ++number)
      }
    },
    setRouterParam (to, from, param) {
      this.SET_ROUTER({
        router: from,
        param: param // param为自定义参数
      })
    },
    clearRouterParam () {
      this.SET_ROUTER({})
      this.clearHighLightInfo()
    },
    initRouteParam (currRouterPath, callback) {
      if (this.router() && this.router().router && this.router().param) {
        if (this.router().router.fullPath === currRouterPath) {
          return this.router().param
        }
      }
      return false
    },
    setHighLightInfo (id, itemName) {
      this.SET_HIGH_LIGHT_INFO({
        id: id,
        itemName: itemName
      })
    },
    clearHighLightInfo () {
      this.SET_HIGH_LIGHT_INFO({})
    },
    highLightTableClass (row, index) {
      if (this.highLightInfo() && this.highLightInfo().id && row[this.highLightInfo().itemName || 'id'] === this.highLightInfo()
        .id) {
        return 'high-light-row'
      } else {
        return ''
      }
    },
    indexTooltip (h, row, data, statusFieldName, classMap) {
      classMap = classMap || {
        0: {
          className: 'invalid',
          text: '已失效'
        },
        1: {
          className: 'default',
          text: '进行中'
        },
        2: {
          className: 'success',
          text: '已完成'
        },
        3: {
          className: 'error',
          text: '被驳回'
        }
      }
      statusFieldName = statusFieldName || 'status'
      let classObj = classMap[row[statusFieldName]]
      let className = null
      let text = null
      if (classObj) {
        className = classObj.className
        text = classObj.text
      }
      row.className = classObj.className
      return this.getIndexTooltip(h, data, className, text)
    },
    getIndexTooltip (h, data, className, text) {
      let returnToolTip = data
      if (text && text !== '') {
        returnToolTip = [h('Tooltip', {
          props: {
            placement: 'left',
            content: text,
            transfer: true
          }
        }, data)]
      }
      let returnDom = [h('div', {
        class: 'index '
      }, returnToolTip)]
      if (className) {
        returnDom.push(h('div', {
          class: 'index-sign-out index ' + className + '-index'
        }, [h('div', {
          class: 'index-sign index ' + className + '-index'
        })]))
      }
      return returnDom
    }
  }
})



// WEBPACK FOOTER //
// ./src/common/api/globalMethod.js